import { Component, css, h, tag } from "omi";

import { NWIcon } from "@/components/atoms/nw-icon";
import { NWTooltip } from "@/components";
import { tailwind } from "@/tailwind";

type Props = {
  helpText: string;
  titleText?: string;
  maxWidth?: string;
  withArrow?: boolean;
};

@tag("nw-help")
export class NWHelp extends Component<Props> {
  static css = [
    tailwind,
    css`
      :host {
        display: inline-block;
        vertical-align: middle;
      }
    `,
  ];

  static propTypes = {
    titleText: String,
    helpText: String,
    maxWidth: String,
    withArrow: Boolean,
  };

  render({ helpText, maxWidth, withArrow = false }: Props) {
    return (
      <div class="text-quaternary cursor-pointer w-fit h-fit">
        <NWTooltip content={helpText} placement="top" arrow={withArrow} maxWidth={maxWidth}>
          <NWIcon name="help" width={16} height={16} />
        </NWTooltip>
      </div>
    );
  }
}
